export const enum MutationNames {
  updateDetailedSites = 'SITES_UPDATE_DETAILED_SITES',
}

export const enum ActionNames {
  getDetailedSiteById = 'SITE_GET_DETAILED_SITE',
  // patchDetailedSite = 'SITE_PATCH_DETAILED_SITE',
}

export const enum GetterNames {
  detailedSites = 'SITE_DETAILED_SITES',
}
